module.exports = __webpack_public_path__ + "img/Gemological_Institute_of_America_logo.eed0828f.svg";